import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/header/Header";
import Tabs from "../../components/tabs/Tabs";
import Footer from "../../components/footer/Footer";
import WatchesBackground from "../../assets/watches_background.svg";
import BackgroundCover from "../../components/backgroundCover/BackgroundCover";
import { isMobile } from "../../utils/appUtils";
import MobilePanel from "../../components/mobilePanel/MobilePanel";
import Tourmalines from "../../pages/tourmalines/Tourmalines";
import Philosophy from "../../pages/philosophy/Philosophy";
import Books from "../../pages/philosophy/Books";
import TourmalineFrequency from "../../pages/elements/TourmolineFrequencies";
import DiamondGlass from "../../pages/elements/DiamondGlass";
import Stores from "../../pages/stores/Stores";
import ClockworkTourmaline from "../../pages/clockwork/Clockwork-tourmalines";
import ClockworkLight from "../../pages/clockwork/Clockwork-light";
import ClockworkAtomic from "../../pages/clockwork/Clockwork-atomic";
import Company from "../../pages/maison/company/Company";
import Innovations from "../../pages/maison/innovations/Innovations";
import Patents from "../../pages/patents/Patents";
import SocialCommitment from "../../pages/maison/socialCommitment/SocialCommitment";
import EnvironmentalCommitment from "../../pages/maison/environmentalCommitment/EnvironmentalCommitment";
import Culture from "../../pages/maison/culture/Culture";
import rawData from "../../utils/tabsData.json";
import Sculptures from "../sculptures/Sculptures";
import Collections from "../watches/collections/Collections";
import ClockWork from "../watches/clockWork/ClockWork";
import CypherGlass from "../watches/cypherGlass/CypherGlass";
import JewelleyCollections from "../jewellery/jewelleryCollections/JewelleryCollections";
import TheBiggestGemstone from "../sculptures/TheBiggestGemstone";
import TourmalineCollection from "../jewellery/jewelleryCollections/TourmalineCollection";
import SnakeCollection from "../jewellery/jewelleryCollections/SnakeCollection";
import ChineseZodiacCollection from "../jewellery/jewelleryCollections/ChineseZodiacCollection";
import HomeTemplate from "./HomeTemplate";
import "./Home.css";
import Watches from "../productDetail/WatchPage";
import FluoringCollection from "../jewellery/jewelleryCollections/FluoringCollection";
import VariantDetail from "../productDetail/VariantDetail";
import { TabsData } from "../../types/navigation";
import Imprint from "../../pages/imprint/Imprint";
import Skridblatnir from "../../pages/elements/Skridblatnir";
import MoneyArt from "../../pages/elements/MoneyArt";
import FidrildiStone from "../../pages/elements/FidrildiStone";
import InfiniteInsight from "../../pages/elements/InfiniteInsight";

interface HomeProps {
  page?: string;
}

const data = rawData as TabsData;

const Home: React.FC<HomeProps> = ({ page }) => {
  const [showBackground, setShowBackground] = useState(true);
  const [activeTab, setActiveTab] = useState<string | null>(null);
  const [clickedTab, setClickedTab] = useState<string | null>(null);
  const [clickedSubTab, setClickedSubTab] = useState<string | null>(null);
  const [activeProduct, setActiveProduct] = useState<string | null>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSubTabs, setActiveSubTabs] = useState<any[]>([]);
  const bgImgRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!clickedTab && !clickedSubTab) {
      setShowBackground(true);
    }
  }, [clickedTab, clickedSubTab]);

  useEffect(() => {
    if (clickedTab) {
      const activeTabData = data.tabs.find((tab) => tab.id === clickedTab);
      if (activeTabData && activeTabData.subtabs) {
        setActiveSubTabs(activeTabData.subtabs.filter(subtab => !subtab.isHidden));
      } else {
        setActiveSubTabs([]);
      }
    }
  }, [clickedTab]);

  const handleTabChange = (tabId: string) => {
    console.log("tabId", tabId);
    setShowBackground(
      tabId !== "tourmalines" &&
      tabId !== "philosophy" &&
      tabId !== "stores" &&
      tabId !== "sculptures"
    );
    setActiveTab(tabId);
    setClickedTab(tabId);
    setClickedSubTab(null);
    setActiveProduct(null);
    if (isMobile()) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleSubTabChange = (subTabId: string | null) => {
    if (subTabId === null) {
      setShowBackground(
        activeTab !== "tourmalines" &&
        activeTab !== "philosophy" &&
        activeTab !== "stores" &&
        activeTab !== "sculptures"
      );
    } else {
      setShowBackground(
        subTabId !== "company" &&
        subTabId !== "our_innovations" &&
        subTabId !== "patents" &&
        subTabId !== "social_commitment" &&
        subTabId !== "environmental_commitment" &&
        subTabId !== "culture" &&
        subTabId !== "collections" &&
        subTabId !== "clockwork" &&
        subTabId !== "cypher_glass" &&
        subTabId !== "jewellery_collections"
      );
    }
    setClickedSubTab(subTabId);
    setActiveProduct(null);
  };

  const handleLogoClick = () => {
    setShowBackground(true);
    setActiveTab(null);
    setClickedTab(null);
    setClickedSubTab(null);
    setActiveProduct(null);
    setIsMobileMenuOpen(false);
  };

  const resetActiveProduct = () => {
    setActiveProduct(null);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prevState) => !prevState);
    if (!isMobileMenuOpen) {
      // When opening the menu, reset all states
      setClickedTab(null);
      setClickedSubTab(null);
      setActiveSubTabs([]);
      setActiveTab(null);
      setShowBackground(true);
      setActiveProduct(null);
    } else {
      // When closing the menu after selection, reset states
      setClickedTab(null);
      setClickedSubTab(null);
      setActiveSubTabs([]);
    }
  };

  const getComponentForTab = (tabId: string | null) => {
    switch (tabId) {
      // case "tourmalines":
      //   return <Tourmalines />;
      // case "philosophy":
      //   return <Philosophy />;
      // case "stores":
      //   return <Stores />;
      // case "sculptures":
      //   return <Sculptures />;
      default:
        return null;
    }
  };

  const getComponentForSubTab = (subTabId: string | null) => {
    switch (subTabId) {
      case "company":
        return <Company />;
      case "our_innovations":
        return <Innovations />;
      case "patents":
        return <Patents />;
      case "social_commitment":
        return <SocialCommitment />;
      case "environmental_commitment":
        return <EnvironmentalCommitment />;
      case "culture":
        return <Culture />;
      case "sculptures":
        return <Sculptures />;
      case "collections":
        return (
          <Collections
            activeTab={activeTab}
            activeSubTab={clickedSubTab}
            setActiveTab={setActiveTab}
            setActiveSubTabs={setActiveSubTabs}
            setShowBackground={setShowBackground}
          />
        );
      case "cypher_glass":
        return (
          <CypherGlass
            activeTab={activeTab}
            activeSubTab={clickedSubTab}
          />
        );
      case "clockwork":
        return (
          <ClockWork
            activeTab={activeTab}
            activeSubTab={clickedSubTab}
          />
        );
      case "jewellery_collections":
        return (
          <JewelleyCollections
            activeTab={activeTab}
            activeSubTab={clickedSubTab}
          />
        );
      default:
        return null;
    }
  };

  const commonProps = {
    onTabChange: handleTabChange,
    activeTab,
    setActiveTab,
    clickedTab,
    setClickedTab,
    clickedSubTab,
    setClickedSubTab: handleSubTabChange,
    setShowBackground,
    activeProduct,
    setActiveProduct,
    isMobile: isMobile(),
    bgImgRef,
    headerRef
  };

  const mobilePanelProps = {
    ...commonProps,
    onLogoClick: handleLogoClick,
    resetActiveProduct: () => setActiveProduct(null),
    isMobileMenuOpen,
    toggleMobileMenu,
    bgImgRef,
    headerRef
  };

  const handleSubTabClick = (subTabId: string) => {
    setClickedSubTab(subTabId);
    setShowBackground(
      subTabId !== "company" &&
      subTabId !== "our_innovations" &&
      subTabId !== "patents" &&
      subTabId !== "social_commitment" &&
      subTabId !== "environmental_commitment" &&
      subTabId !== "culture" &&
      subTabId !== "collections" &&
      subTabId !== "clockwork" &&
      subTabId !== "cypher_glass" &&
      subTabId !== "jewellery_collections"
    );
    setIsMobileMenuOpen(false);
  };

  const renderComponent = () => {
    // Handle direct page prop rendering first
    if (page === 'patents') {
      return <Patents />;
    }
    if (page === 'imprint') {
      return <Imprint />;
    }
    // Add other direct page checks here if needed for consistency
    if (page === 'clockworktourmaline') {
      return <ClockworkTourmaline />;
    }
    if (page === 'clockworklight') {
      return <ClockworkLight />;
    }
    if (page === 'atomic') {
      return <ClockworkAtomic />;
    }
    if (page === 'diamondglass') {
      return <DiamondGlass />;
    }
    if (page === 'tourmalinefrequency') {
      return <TourmalineFrequency />;
    }
    if (page === 'the_biggest_gemstone') {
      return <TheBiggestGemstone />;
    }
    if (page === 'skridblatnir') {
      return <Skridblatnir />;
    }
    if (page === 'money_art') {
      return <MoneyArt />;
    }
     if (page === 'fidrildi_stone') {
       return <FidrildiStone />;
     }
    if (page === 'infinite_insight') {
      return <InfiniteInsight />;
    }
    if (page === 'cypherglass') { // Assuming cypherglass page prop maps here
      return <CypherGlass activeTab={activeTab} activeSubTab={clickedSubTab} />;
    }
    if (page === 'stores') {
        return <Stores />;
    }
    if (page === 'books') {
        return <Books />;
    }
    if (page === 'philosophy') {
        return <Philosophy />;
    }
     if (page === 'tourmalines') {
       return <Tourmalines />;
     }
      if (page === 'chinese_zodiacs') {
        return <ChineseZodiacCollection />;
      }
      if (page === 'fluoring') {
        return <FluoringCollection />;
      }
      if (page === 'snake') {
        return <SnakeCollection />;
      }
       if (page === 'tourmaline') { // Assuming collections/tourmaline page prop maps here
         return <TourmalineCollection />;
       }
       if (page === 'company') {
            return <Company />;
       }
      if (page === 'our_innovations') {
        return <Innovations />;
      }
       if (page === 'social_commitment') {
         return <SocialCommitment />;
       }
      if (page === 'environmental_commitment') {
        return <EnvironmentalCommitment />;
      }
       if (page === 'culture') {
         return <Culture />;
       }
       if (page === 'watches') {
        return <Watches />;
       }
       if (page === 'variant') {
        return <VariantDetail />;
       }

    // Fallback to tab/subtab logic
    if (clickedSubTab) {
      return getComponentForSubTab(clickedSubTab);
    }
    if (clickedTab) {
      return getComponentForTab(clickedTab);
    }

    // Default to HomeTemplate if no specific page or tab is active
    return <HomeTemplate />; // Render HomeTemplate without unnecessary props
  };

  return (
    <div className="home-container">
      {isMobile() ? (
        <>
          <Header
            onLogoClick={handleLogoClick}
            resetActiveProduct={resetActiveProduct}
            isMobileMenuOpen={isMobileMenuOpen}
            toggleMobileMenu={toggleMobileMenu}
          />
          {isMobileMenuOpen ? (
            <MobilePanel {...mobilePanelProps} />
          ) : (
            <div className="mobile-content">
              {clickedTab && getComponentForTab(clickedTab)}

              {clickedTab !== "sculptures" &&
                clickedTab &&
                activeSubTabs.length > 0 && (
                  <div className="mobile-subtabs">
                    <ul>
                      {activeSubTabs.map((subtab, index) => (
                        <React.Fragment key={subtab.id}>
                          <li
                            className="subtab-item"
                            onClick={() => handleSubTabClick(subtab.id)}
                          >
                            <span
                              className={`subtab-label ${clickedSubTab === subtab.id ? "active" : ""
                                }`}
                            >
                              {subtab.label.en}
                            </span>
                          </li>
                          {index < activeSubTabs.length - 1 && (
                            <span className="subtab-separator">|</span>
                          )}
                        </React.Fragment>
                      ))}
                    </ul>
                  </div>
                )}

              {clickedSubTab && getComponentForSubTab(clickedSubTab)}
            </div>
          )}
        </>
      ) : (
        <div className="desktop-header-wrapper">
          <Header
            onLogoClick={handleLogoClick}
            resetActiveProduct={resetActiveProduct}
            isMobileMenuOpen={isMobileMenuOpen}
            toggleMobileMenu={toggleMobileMenu}
            headerRef={headerRef}
          />
          <Tabs
            tabs={data.tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            clickedTab={clickedTab}
            setClickedTab={setClickedTab}
            clickedSubTab={clickedSubTab}
            setClickedSubTab={setClickedSubTab}
            setShowBackground={setShowBackground}
            isMobile={isMobile()}
            bgImgRef={bgImgRef}
            headerRef={headerRef}
            onLogoClick={handleLogoClick}
            resetActiveProduct={resetActiveProduct}
          />
        </div>
      )}

      {!isMobile() && !isMobileMenuOpen && renderComponent()}
      {isMobile() && showBackground && renderComponent()}
      <Footer />
    </div>
  );
};

export default Home;
